/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 6c719b74f5ac
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import { CreateRequest, CreateRequest$zodSchema } from "./createrequest.js";
import {
  MessageResponse,
  MessageResponse$zodSchema,
} from "./messageresponse.js";

export type CreateTransformationGlobals = { cloud_name?: string | undefined };

export const CreateTransformationGlobals$zodSchema: z.ZodType<
  CreateTransformationGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type CreateTransformationRequest = {
  transformation: string;
  create_request: CreateRequest;
};

export const CreateTransformationRequest$zodSchema: z.ZodType<
  CreateTransformationRequest
> = z.object({
  create_request: CreateRequest$zodSchema.describe(
    "The named transformation definition.",
  ),
  transformation: z.string().describe(
    "The valid transformation name to create.",
  ),
});

export type CreateTransformationResponse = MessageResponse | ApiError;

export const CreateTransformationResponse$zodSchema: z.ZodType<
  CreateTransformationResponse
> = z.union([
  MessageResponse$zodSchema,
  ApiError$zodSchema,
]);
